module.exports = __webpack_public_path__ + "static/media/p4_s2.fc94e895.ogg";